import campaignSenderEmail from '@/http/requests/campaignSenderEmail'

export default {
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaignSenderEmail.add(data).then(response => {
        commit('ADD_EMAIL', response.data.data.createCampaignSenderEmail)
        resolve(response)
      })
        .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, { id, brevoId }) {
    return new Promise((resolve, reject) => {
      campaignSenderEmail.delete(id, brevoId)
        .then(response => {
          commit('DELETE_EMAIL', id);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaignSenderEmail.update(data)
        .then(response => {
          commit('UPDATE_EMAIL', data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  validate(_, data) {
    return new Promise((resolve, reject) => {
      campaignSenderEmail.validate(data).then(response => {
        resolve(response)
      })
        .catch((error) => { reject(error) })
    })
  },
  fetchPaginated({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaignSenderEmail.fetchPaginated(data.sortName, data.page, data.itemsPerPage, data.type, data.word)
        .then((response) => {
          const parsedData = response.data.data.getSenderEmailsPaginated;

          commit('SET_EMAILS_PAGINATED', parsedData);
          resolve(response);
        })
        .catch((exception) => {
          reject(exception);
        });
    })
  },
  updateStatus({ commit }, data) {
    commit('UPDATE_SENDER_STATUS', data);
  }
}
